import { Component, Vue } from 'vue-property-decorator';
import { authExternal } from '@/helpers/AuthExternal';
import { parseRedirectParam, withSellerPrefix } from '@/helpers/route';
import { logout } from '@/state/Authentication';
@Component
export default class extends Vue {
    beforeRouteEnter(to, _, next) {
        const redirect = parseRedirectParam(to.query.redirect);
        if (redirect) {
            next(async () => {
                // External auth methods (Auth0, SFEC, etc.) handle navigation during
                // logout — e.g. Auth0 redirects to its /v2/logout endpoint. Only
                // manually navigate when no external auth is in play.
                await logout(undefined, redirect);
                if (!authExternal.isExternalAuth()) {
                    window.location.href = withSellerPrefix(redirect);
                }
            });
        }
        else {
            next((vm) => {
                logout(vm.$router, '/');
            });
        }
    }
}
